import { jsxs as s, jsx as e } from "../../../_virtual/jsx-runtime.mjs";
import p from "react";
import n from "../../../depend/classnames/index.mjs";
import { reoFormItemInput as I, reoFormItemErrorContent as g, reoFormItemErrorAuxiliary as N, reoFormItemInputContent as C } from "../css/ReoFormItem.mjs";
import { CompErrorList as x } from "./ErrorList.mjs";
const w = (r) => {
  const { marginBottom: t, fixMarginBottom: i, errors: o, warnings: m, fieldId: a, status: l, help: c, onErrorVisibleChanged: u } = r, d = p.useMemo(
    () => n(
      I,
      "reo-basic-form-item-input-wrap",
      r.className
    ),
    [r.className]
  ), f = t !== null || o.length || m.length ? /* @__PURE__ */ s("div", { className: g, children: [
    /* @__PURE__ */ e(
      x,
      {
        fieldId: a,
        errors: o,
        warnings: m,
        help: c,
        helpStatus: l,
        onVisibleChanged: u
      }
    ),
    !!t && !i && // 辅助占位元素，当 fixMarginBottom 为 false时，用于撑开ErrorList的高度
    /* @__PURE__ */ e(
      "div",
      {
        className: N,
        style: { height: t }
      }
    )
  ] }) : null, h = /* @__PURE__ */ e("div", { className: n(C, "reo-basic-form-item-input-content"), children: r.children });
  return /* @__PURE__ */ s("div", { className: d, children: [
    h,
    f
  ] });
};
export {
  w as default
};
//# sourceMappingURL=ItemInput.mjs.map
